import React from "react";
import { Box, Typography } from "@mui/material";
import {
  BRAND_WORLD_ADDRESS_LINE,
  BRAND_WORLD_INVOICE_ISSUER,
  BRAND_WORLD_LOGO_URL,
  isBrandWorldParty,
} from "../../utils/invoiceIssuer";

const PICompanyHeader = ({
  seller,
  buyer,
  website,
  title,
  titleBg = "#2261A2",
  titleRadius = "0px",
  textStyle,
  websiteSx,
  headerRef,
  logoBoxSx,
}) => {
  const sellerIsBrandWorld = isBrandWorldParty(seller);
  const buyerIsBrandWorld = isBrandWorldParty(buyer);
  const sellerLogoSrc = sellerIsBrandWorld
    ? BRAND_WORLD_LOGO_URL
    : seller?.SellerCompanyLogo;
  const buyerLogoSrc = buyerIsBrandWorld
    ? BRAND_WORLD_LOGO_URL
    : buyer?.BuyerCompanyLogo;
  const sellerName = sellerIsBrandWorld
    ? "BRAND WORLD"
    : seller?.SellerCompanyName;
  const sellerAddressLine = sellerIsBrandWorld
    ? seller?.Address?.AddressLine || BRAND_WORLD_ADDRESS_LINE
    : seller?.Address?.AddressLine;
  const sellerGstin = sellerIsBrandWorld
    ? seller?.GSTIN || BRAND_WORLD_INVOICE_ISSUER.gstin
    : seller?.GSTIN;
  const websiteStyles = websiteSx || {
    color: "#445FD2",
    fontSize: "14px",
    fontWeight: 600,
    fontFamily: "Poppins",
    fontStyle: "normal",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    height: "130px",
    width: "30%",
    borderLeft: "1px solid #cdcdcd",
  };
  
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          height: "auto",
          mx: "auto",
        }}
        ref={headerRef}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            height: "130px",
            width: "30%",
            ...logoBoxSx,
          }}
        >
          <img
            src={sellerLogoSrc}
            style={{ width: "100px", height: "100px" }}
            alt="SellerCompanyLogo Icon"
            title="SellerCompanyLogo Icon"
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            borderLeft: "1px solid #cdcdcd",
            height: "130px",
            width: "40%",
          }}
        >
          <Typography
            sx={{
              ...textStyle,
              color: "rgba(107, 122, 153, 1)",
              opacity: 1,
              fontWeight: 600,
            }}
          >
            {sellerName}
          </Typography>
          <Typography
            sx={{
              ...textStyle,
              textAlign: "center",
              fontSize: "11px",
              color: "rgba(107, 122, 153, 1)",
              opacity: 1,
              fontWeight: 600,
            }}
          >
            {sellerAddressLine}
          </Typography>
          <Typography sx={{ color: "rgba(80, 80, 80, 1)", opacity: 1 }}>
            Tel:{seller?.SellerCompanyContact}
          </Typography>
          <Typography sx={{ color: "rgba(80, 80, 80, 1)", opacity: 1 }}>
            GSTIN:{sellerGstin}
          </Typography>
        </Box>
        <Box sx={websiteStyles}>
          {buyerLogoSrc ? (
            <img
              src={buyerLogoSrc}
              style={{ width: "100px", height: "100px", objectFit: "contain" }}
              alt="BuyerCompanyLogo Icon"
              title="BuyerCompanyLogo Icon"
            />
          ) : null}
        </Box>
      </Box>
      <Box
        sx={{
          width: "100%",
          height: "42px",
          mx: "auto",
          background: titleBg,
          borderRadius: titleRadius,
        }}
      >
        <Typography
          sx={{
            ...textStyle,
            color: "white",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            alignContent: "center",
            height: "100%",
          }}
        >
          {title}
        </Typography>
      </Box>
    </>
  );
};

export default PICompanyHeader;
